import axios from 'axios';

// localStorage "admin" holds the login API response; [0].token authorises
// every admin API call (sent as the X-Auth-Token header).
export function authToken() {
  try {
    const admin = JSON.parse(localStorage.getItem("admin"));
    return (Array.isArray(admin) && admin[0]?.token) || "";
  } catch {
    return "";
  }
}

export function authHeaders() {
  const token = authToken();
  return token ? { "X-Auth-Token": token } : {};
}

export function goToLogin() {
  localStorage.clear();
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
}

export async function logout() {
  try {
    await axios.post('/api/user/logout.php');
  } catch (e) {
    // token is dropped locally either way
  }
  goToLogin();
}

// Attach the token to every axios request; an expired or revoked token
// (HTTP 401) sends the user back to the login page.
export function setupAuth() {
  axios.interceptors.request.use((config) => {
    const token = authToken();
    if (token) config.headers["X-Auth-Token"] = token;
    return config;
  });
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) goToLogin();
      return Promise.reject(error);
    }
  );
}
